/* eslint-disable no-case-declarations */
import {
  BusinessGroupActions,
  GET_MY_BUSINESS_GROUPS,
  SELECT_CURRENT_BUSINESS_GROUPS
} from "../../types/actions/BusinessGroup.actions";
import { BusinessGroup } from "../../types/models/BusinessGroup";
import { BusinessGroupState } from "../../types/models/BusinessGroupState";

const initialSettings: BusinessGroupState = {
  businessGroups: undefined,
  currentBusinessGroup: undefined
};

const BusinessGroupReducer = (state = initialSettings, action: BusinessGroupActions) => {

  switch (action.type) {
    case GET_MY_BUSINESS_GROUPS:
      const businessGroups: BusinessGroup[] | undefined = action.payload;
      return {
        ...state,
        businessGroups: businessGroups
      };
    case SELECT_CURRENT_BUSINESS_GROUPS:
      return {
        ...state,
        currentBusinessGroup: action.payload,
      };
    default:
      return state;
  }
};

export default BusinessGroupReducer;
